export class RenovarOportunidadPayload {
  renovationAt: string = "";   // ISO 8601: nueva fecha de renovación
}
